import React from 'react';

/** Mini terminal chrome used for status chips and floating panels. */
export default function TerminalFrame({
  title = 'session',
  children,
  className = '',
  bodyClassName = ''
}) {
  return (
    <div className={`terminal overflow-hidden ${className}`}>
      <div className="flex items-center gap-2 border-b border-slate-200/80 px-3 py-2 dark:border-emerald-500/10">
        <span aria-hidden="true" className="h-2 w-2 rounded-full bg-rose-400/80" />
        <span aria-hidden="true" className="h-2 w-2 rounded-full bg-amber-400/80" />
        <span aria-hidden="true" className="h-2 w-2 rounded-full bg-emerald-400/80" />
        <span className="ml-2 truncate text-[10px] uppercase tracking-[0.16em] text-slate-400">
          {title}
        </span>
      </div>
      <div className={`p-3 text-[11px] leading-relaxed text-slate-600 dark:text-slate-300 ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
}
